import React from 'react';

import ResearchItem, {
  ResearchTypes
} from '@buyside/components/presentation/ResearchItem/researchItem';
import DocumentList from '@buyside/components/presentation/DocumentList/documentList';
import DelayedAccessAlert, {
  Location
} from '@buyside/components/presentation/AccessControl/delayedAccessAlert';

import { profileAttachmentUrl } from '@buyside/util/urlHelper';

import { UserProfileShowPageQuery } from '@interfaces/graphql-typings';

const Research: React.FC<{ userProfile: UserProfileShowPageQuery['userProfile'] }> = ({
  userProfile
}): React.ReactElement => {
  const { user, profileAttachments } = userProfile;

  return (
    <div>
      {user?.recentIdea && (
        <div>
          <h4>Most Recently Published Idea</h4>
          <DelayedAccessAlert id={Location.profileResearch} isPublic={false} userId={user.id} />
          <ResearchItem {...user.recentIdea} researchType={ResearchTypes.IDEA} showUserDetails />
        </div>
      )}
      {profileAttachments && Boolean(profileAttachments.length) && (
        <DocumentList
          title="Featured Research Documents"
          documents={profileAttachments}
          urlFn={profileAttachmentUrl}
        />
      )}
    </div>
  );
};

export default Research;
